'use strict';

var _regeneratorRuntime = require("@babel/runtime/regenerator");
var _createClass = require("@babel/runtime/helpers/createClass");
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var QuickLRU = /*#__PURE__*/function (_Symbol$iterator) {
  function QuickLRU(opts) {
    opts = Object.assign({}, opts);
    if (!(opts.maxSize && opts.maxSize > 0)) {
      throw new TypeError('`maxSize` must be a number greater than 0');
    }
    this.maxSize = opts.maxSize;
    this.cache = new Map();
    this.oldCache = new Map();
    this._size = 0;
  }
  var _proto = QuickLRU.prototype;
  _proto._set = function _set(key, value) {
    this.cache.set(key, value);
    this._size++;
    if (this._size >= this.maxSize) {
      this._size = 0;
      this.oldCache = this.cache;
      this.cache = new Map();
    }
  };
  _proto.get = function get(key) {
    if (this.cache.has(key)) {
      return this.cache.get(key);
    }
    if (this.oldCache.has(key)) {
      var value = this.oldCache.get(key);
      this._set(key, value);
      return value;
    }
  };
  _proto.set = function set(key, value) {
    if (this.cache.has(key)) {
      this.cache.set(key, value);
    } else {
      this._set(key, value);
    }
    return this;
  };
  _proto.has = function has(key) {
    return this.cache.has(key) || this.oldCache.has(key);
  };
  _proto.peek = function peek(key) {
    if (this.cache.has(key)) {
      return this.cache.get(key);
    }
    if (this.oldCache.has(key)) {
      return this.oldCache.get(key);
    }
  };
  _proto.delete = function _delete(key) {
    if (this.cache.delete(key)) {
      this._size--;
    }
    this.oldCache.delete(key);
  };
  _proto.clear = function clear() {
    this.cache.clear();
    this.oldCache.clear();
    this._size = 0;
  };
  _proto.keys = /*#__PURE__*/_regeneratorRuntime.mark(function keys() {
    var _iterator, _step, el;
    return _regeneratorRuntime.wrap(function keys$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _iterator = _createForOfIteratorHelperLoose(this);
        case 1:
          if ((_step = _iterator()).done) {
            _context.next = 7;
            break;
          }
          el = _step.value;
          _context.next = 5;
          return el[0];
        case 5:
          _context.next = 1;
          break;
        case 7:
        case "end":
          return _context.stop();
      }
    }, keys, this);
  });
  _proto.values = /*#__PURE__*/_regeneratorRuntime.mark(function values() {
    var _iterator2, _step2, el;
    return _regeneratorRuntime.wrap(function values$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _iterator2 = _createForOfIteratorHelperLoose(this);
        case 1:
          if ((_step2 = _iterator2()).done) {
            _context2.next = 7;
            break;
          }
          el = _step2.value;
          _context2.next = 5;
          return el[1];
        case 5:
          _context2.next = 1;
          break;
        case 7:
        case "end":
          return _context2.stop();
      }
    }, values, this);
  });
  _proto[_Symbol$iterator] = /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _iterator3, _step3, el, _iterator4, _step4, _el;
    return _regeneratorRuntime.wrap(function _callee$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _iterator3 = _createForOfIteratorHelperLoose(this.cache);
        case 1:
          if ((_step3 = _iterator3()).done) {
            _context3.next = 7;
            break;
          }
          el = _step3.value;
          _context3.next = 5;
          return el;
        case 5:
          _context3.next = 1;
          break;
        case 7:
          _iterator4 = _createForOfIteratorHelperLoose(this.oldCache);
        case 8:
          if ((_step4 = _iterator4()).done) {
            _context3.next = 15;
            break;
          }
          _el = _step4.value;
          if (this.cache.has(_el[0])) {
            _context3.next = 13;
            break;
          }
          _context3.next = 13;
          return _el;
        case 13:
          _context3.next = 8;
          break;
        case 15:
        case "end":
          return _context3.stop();
      }
    }, _callee, this);
  });
  _createClass(QuickLRU, [{
    key: "size",
    get: function get() {
      var oldCacheSize = 0;
      for (var _iterator5 = _createForOfIteratorHelperLoose(this.oldCache), _step5; !(_step5 = _iterator5()).done;) {
        var el = _step5.value;
        if (!this.cache.has(el[0])) {
          oldCacheSize++;
        }
      }
      return this._size + oldCacheSize;
    }
  }]);
  return QuickLRU;
}(Symbol.iterator);
module.exports = QuickLRU;